//TODO Add API_KEYS to the requests

const httpClient = {
  post: function (_url, _data, _method, _contentType) {
    let headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      mode: "no-cors",
    };
    if (_contentType === null) headers = { Accept: "application/json" };
    return new Promise((resolve, reject) => {
      // console.log('Fetching url: ', _url);
      fetch(_url, {
        body: _contentType === null ? _data : JSON.stringify(_data),
        method: _method ?? "POST",
        mode: "cors",
        headers: headers,
      })
        .then((response) => {
          // console.log(_url, ' Response ', response);
          response
            .json()
            .then((jsonResponse) => {
              // console.log(_url, ' Json Response ', jsonResponse);
              resolve(jsonResponse);
            })
            .catch((error) => {
              console.log(_url, " error while parsing json ", error);
              reject(error);
            });
        })
        .catch((error) => {
          console.log(_url, " error while getting response ", error);
          reject(error);
        });
    });
  },

  put: function (_url, _data, _headers, _contentType) {
    let headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      ..._headers,
    };

    return new Promise((resolve, reject) => {
      // console.log('Fetching url: ', _url);
      fetch(_url, {
        body: _contentType === null ? _data : JSON.stringify(_data),
        method: "PUT",
        mode: "cors",
        headers: headers,
      })
        .then((response) => {
          response
            .json()
            .then((jsonResponse) => {
              resolve(jsonResponse);
            })
            .catch((error) => {
              console.log(_url, " error while parsing json ", error);
              reject(error);
            });
        })
        .catch((error) => {
          console.log(_url, " error while getting response ", error);
          reject(error);
        });
    });
  },

  get: function (_url, _headers = {}) {
    return new Promise((resolve, reject) => {
      // console.log('Fetching url: ', _url);
      fetch(_url, {
        method: "GET",
        headers: { Accept: "application/json", ..._headers },
      })
        .then((response) => {
          // console.log(_url, ' Response ', response);
          response
            .json()
            .then((jsonResponse) => {
              resolve(jsonResponse);
            })
            .catch((error) => {
              console.log(_url, " error while parsing json ", error);
              reject(error);
            });
        })
        .catch((error) => {
          console.log(_url, " error while getting response ", error);
          reject(error);
        });
    });
  },

  postFile: function (_url, _data, _headers = {}) {
    // const data = document.querySelector('form')
    // const formData = Object.fromEntries(new FormData(data).entries());
    // formData.image = _data?.image
    let headers = {
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
      ..._headers,
    };
    // console.log(_data)
    return new Promise((resolve, reject) => {
      let requestOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(_data),
        mode: "cors",
      };
      // console.log(requestOptions.body)
      fetch(_url, requestOptions)
        .then((response) => {
          response
            .json()
            .then((jsonResponse) => {
              console.log(_url, " Json Response ", jsonResponse);
              resolve(jsonResponse);
            })
            .catch((error) => {
              console.log(_url, " error while parsing json ", error);
              reject(error);
            });
        })
        .catch((error) => {
          console.log(_url, " error while getting response ", error);
          reject(error);
        });
    });
  },

  delete: function (_url, _headers) {
    return new Promise((resolve, reject) => {
      fetch(_url, {
        method: "DELETE",
        headers: _headers,
      })
        .then((response) => {
        //   console.log(_url, ' Response ', response);
          response
            .json()
            .then((jsonResponse) => {
              resolve(jsonResponse);
            })
            .catch((error) => {
              console.log(_url, " error while deleting ", error);
              reject(error);
            });
        })
        .catch((error) => {
          console.log(_url, " error while getting response ", error);
          reject(error);
        });
    });
  },
};

const jsonToFormData = (_json) => {
  let data = new FormData();
  for (let key in _json) {
    if (_json[key] !== undefined) data.append(key, _json[key]);
  }

  return data;
};

const countries = [
  { value: "Cameroon", label: "Cameroon" },
  { value: "Rwanda", label: "Rwanda" },
  { value: "Kenya", label: "Kenya" },
];

export { jsonToFormData, httpClient, countries };
// export default httpClient;
